import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMQ: CultureInfo = {
  name: 'fr-MQ',
  displayName: 'français (Martinique)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MQ',
  parent: CultureInfoFr
};
